export const companyMortgageCommand = {
  addAmortization: 'addAmortization',
};
